import BackendService from "../../../backend/controller/BackendService";
import LlmConversationMessage, { LlmMessageSender } from "../../../conversation/model/LlmConversationMessage";
import DebugModel from "../../../debug/model/DebugModel";
import PlayerModel from "../../../player/model/PlayerModel";
import ConversationReflection from "../../model/ConversationReflection";
import ConversationReflectionMessage, { ReflectionMessageSender } from "../../model/ConversationReflectionMessage";
import ConversationReflectionState from "./ConversationReflectionState";
import EndingTurnConversationReflectionState from "./EndingTurnConversationReflectionState";
import PlayerTurnConversationReflectionState from "./PlayerTurnConversationReflectionState";

export default class AiTurnConversationReflectionState extends ConversationReflectionState {
    /**
     * 
     * @param {string} chapterId
     * @param {ConversationReflection} conversation 
     * @param {BackendService} backendService 
     * @param {PlayerModel} playerModel
     * @returns {Promise<ConversationReflectionState>}
     */
    async execute(chapterId, conversation, backendService, playerModel) {
        try {
            const conversationReflectionResponse = await backendService.conversationReflection({
                chapterId: chapterId,
                conversationId: conversation.id,
                conversationHistory: conversation.conversationHistoryForLLM,
                playerName: playerModel.getTrimmedPlayerName(),
            });

            // Save a snapshot. Pointers on placement:
            // - We save before new player input - as they can enter messages violating content policy.
            // - We save just after testing player input.
            // - We save before adding the AI output to the conversation history - as we wan't to reset if a player input is causing issues.
            this.dispatchEvent(ConversationReflectionState.SAVE_SNAPSHOT);

            conversation.addConversationHistory({
                llmConversationMessages: [new LlmConversationMessage(LlmMessageSender.ASSISTANT, conversationReflectionResponse.message)],
                gameConversationMessages: [new ConversationReflectionMessage(ReflectionMessageSender.COACH, conversationReflectionResponse.message)],
            });

            // Log the reflection summary.
            if (ranj.DEBUG || DebugModel.debugContent) {
                console.log(`%c📙 Reflection summary:\n${conversationReflectionResponse.summary}`, 'background: #ffda7d; font-size: 16px; color: black;');
            }
            conversation.summary = conversationReflectionResponse.summary;

            if (conversationReflectionResponse.finished) {
                const nextState = new EndingTurnConversationReflectionState();
                return Promise.resolve(nextState);
            }
        } catch (error) {
            console.error(`[${AiTurnConversationReflectionState.name}] execute error: `, error);
            return Promise.reject(error);
        }

        const nextState = new PlayerTurnConversationReflectionState();
        return Promise.resolve(nextState);
    }
}